var render = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "ssh-pre", class: { "ssh-pre--dark": _vm.dark }, attrs: { "data-type": _vm.language, "data-label": _vm.label || null } }, [_vm.copyButton ? _c("button", { staticClass: "ssh-pre__copy", on: { "click": _vm.copyCode } }, [_vm._t("copy-button", function() {
    return [_vm._v("Copy")];
  })], 2) : _vm._e(), _vm._v(" "), _c("pre", { ref: "code", staticClass: "ssh-pre__content", domProps: { "innerHTML": _vm._s(_vm.content) } })]);
};
var staticRenderFns = [];
var simpleSyntaxHighlighter_vue_vue_type_style_index_0_lang = "";
function normalizeComponent(scriptExports, render2, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render2) {
    options.render = render2;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const regexBasics = {
  quote: /("(?:\\"|[^"])*")|('(?:\\'|[^'])*')/,
  comment: /(\/\/.*?(?:\n|$)|\/\*.*?\*\/)/,
  htmlTag: /(<([^>])*>)/,
  htmlentity: /(&amp;[a-zA-Z0-9#]+;)/,
  punctuation: /(!==?|(?:[[\](){}.:;,+\-?=!]|&lt;|&gt;)+|&&|\|\|)/,
  number: /(-?(?:\.\d+|\d+(?:\.\d+)?))/,
  boolean: /\b(true|false)\b/
};
const dictionary = {
  shell: {
    quote: regexBasics.quote,
    comment: /(#.*?)(?:\n|$)/,
    keyword: /(?:^|\b)(npm|yarn|install|run)(?:\b|$)/,
    param: /( --(?:save|save-dev))(?:\s|$)/
  },
  xml: {
    doctype: /(&lt;\!DOCTYPE.*?&gt;)/,
    quote: regexBasics.quote,
    comment: /(&lt;!--.*?--&gt;)/,
    htmlentity: regexBasics.htmlentity,
    tag: /(&lt;\/?)([a-zA-Z\-:]+)(.*?)(\/?&gt;)/
  },
  html: {
    doctype: /(DOCTYPE)/,
    quote: regexBasics.quote,
    comment: /(&lt;!--.*?--&gt;)/,
    htmlentity: regexBasics.htmlentity,
    tag: /(&lt;\/?)([a-z]\w*)(.*?)(\/?&gt;)/
  },
  "html-vue": {
    doctype: /(DOCTYPE)/,
    quote: regexBasics.quote,
    comment: /(&lt;!--.*?--&gt;)/,
    htmlentity: regexBasics.htmlentity,
    tag: /(&lt;\/?)([a-zA-Z][\w\d-]*)((?:.|\s)*?)(\/?&gt;)/
  },
  pug: {
    text: /((?:^|\n)[ \t]*|^)\|([ \t]*)([^\n]+(?=\s*(?:\n|$)))/,
    text2: /([ \t]*)([.#\-\w\d]+(?:\([^)]*\))*)\.\n((?:\n+(?=\4[ \t]+)|(?=\4[ \t]+).+?(?:\n|$)*?)*)(?=\s*(?:\n|$))/,
    quote: regexBasics.quote,
    comment: /(^|\n)([ \t]*|^)(\/\/-[ \t]*(?:[^\n]*?(?:\n\10[ \t]+[^\n]*)+|[^\n]+(?=\n|$)))/,
    tag: /([a-zA-Z][\w\d-]*|)([.#][a-zA-Z][-.\w\d]*|)\b(?:\((.*?)\))?(\.?)([ \t]*)([^\n]+)?(?=\n|$)/,
    punctuation: /(!==?|(?:[#[\]().,+\-?=!|]|&lt;|&gt;)+)/
  },
  css: {
    quote: regexBasics.quote,
    comment: /(\/\*.*?\*\/)/,
    pseudo: /(:(?:hover|active|focus|visited|not|before|after|(?:first|last|nth)-child))/,
    "selector keyword vendor": /(@-(?:moz|o|webkit|ms)-(?=keyframes\s))/,
    "selector keyword": /((?:@(?:import|media|font-face|keyframes)|screen|print|and)(?=[\s({])|keyframes|\s(?:ul|ol|li|table|div|pre|p|a|img|br|hr|h[1-6]|em|strong|span|html|body|iframe|video|audio|input|button|form|label|fieldset|small|abbr|i|dd|dt)\b)/,
    variable: /(--[a-zA-Z0-9\-]+)/,
    selector: /((?:[.#-\w*+ >:,[\]="~\n]|&gt;)+)(?=\s*\{)/,
    "attribute keyword vendor": /(-(?:moz|o|webkit|ms)-(?=transform|transition|user-select|tap-highlight-color|animation|background-size|box-shadow))/,
    "attribute keyword": /\b(content|float|display|position|top|left|right|bottom|(?:(?:max|min)-)?width|(?:(?:max|min|line)-)?height|font(?:-(?:family|style|size|weight|variant|stretch))?|vertical-align|color|opacity|visibility|z-index|pointer-events|user-select|transform(?:-(?:origin|style|delay|duration|property|timing-function))?|transition(?:-(?:delay|duration))?|animation(?:-(?:name|delay|duration|direction|fill-mode))?|backface-visibility|backdrop-filter|background(?:-(?:color|position|image|repeat|size|attachment|origin|clip|blend-mode))?|(?:padding|margin|border)(?:-(?:top|left|right|bottom))?|border(?:-(?:radius|color|width|style|spacing))|white-space|text-(?:align|transform|decoration|shadow|indent)|overflow(?:-(?:x|y))?|(?:letter|word)-spacing|word-break|box-(?:sizing|shadow)|stroke(?:-(?:width|opacity|dasharray|dashoffset|linecap|linejoin))?|fill|speak|outline|user-select|cursor|flex(?:-(?:direction|flow|grow|shrink|basis|wrap))?|(?:justify|align)-(?:content|self|items))(?=\s*:)/,
    "value keyword vendor": /(-(?:moz|o|webkit|ms)-(?=linear-gradient))/,
    "value keyword": /\b(inherit|initial|normal|none|unset|auto|inline(?:-(?:block|flex))?|block|flex|absolute|relative|static|fixed|sticky|hidden|visible|top|left|right|bottom|center|middle|baseline|solid|dotted|dashed|line-through|(?:over|under)line|wavy|double|(?:pre-|no)?wrap|pre|break-word|(?:upper|lower)case|capitalize|italic|bold|attr\(.*?\)|linear|ease(?:-in)?(?:-out)?|all|infinite|cubic-bezier|(?:translate|rotate)(?:[X-Z]|3d)?|skew[XY]?|scale|(?:no-)?repeat|repeat(?:-x|-y)|contain|cover|url|(?:repeating-)?(?:linear|radial)-gradient|inset|pointer|(?:flex-)?(?:start|end)|space-(?:between|evenly|around)|stretch|revert|row(?:-reverse)?|column(?:-reverse)?)(?=\s*[,;}(]|\s+[\da-z!])/,
    "value keyword important": /( ?!important)/,
    number: regexBasics.number,
    color: /(transparent|#(?:[\da-fA-F]{6}|[\da-fA-F]{3})|rgba?\([\d., ]*\))/,
    htmlentity: /(&.*?;)/,
    punctuation: /([:,;{}@#()!]+|&lt;|&gt;)/,
    attribute: /([a-zA-Z-]+)(?=\s*:)/,
    unit: /(px|pt|cm|%|r?em|m?s|deg|vh|vw|vmin|vmax)(?=(?:\s*[;,{}})]|\s+[-\da-z#]))/
  },
  json: {
    quote: regexBasics.quote,
    comment: regexBasics.comment,
    number: regexBasics.number,
    boolean: regexBasics.boolean,
    punctuation: /([[\](){}:;,-]+)/
  },
  js: {
    quote: regexBasics.quote,
    comment: regexBasics.comment,
    number: /\b(\d+(?:\.\d+)?|null)\b/,
    boolean: regexBasics.boolean,
    this: /\b(this)(?=\W)/,
    keyword: /\b(new|getElementsBy(?:Tag|Class|)Name|getElementById|querySelector|querySelectorAll|arguments|if|else|do|return|case|default|(?:f|F)unction|typeof|instanceof|undefined|document|window|while|for|forEach|switch|in|break|continue|delete|length|var|let|const|export|import|as|require|from|Class|constructor|Number|Boolean|String|Array|Object|RegExp|Integer|Date|Promise|async|await|(?:clear|set)(?:Timeout|Interval)|parse(?:Int|Float)|Math(?=\.)|isNaN)(?=\W)/,
    punctuation: /(!==?|(?:[[\]!(){}:;,+\-%*/?=]|&lt;|&gt;)+|\.+(?![a-zA-Z])|&amp;&amp;|\|\|)/,
    variable: /(\.?[a-zA-Z_][\w\d]*)/,
    htmlentity: /(&.*?;)/,
    "external-var": /(\$|jQuery|JSON)(?=\W|$)/
  },
  php: {
    quote: regexBasics.quote,
    comment: regexBasics.comment,
    special: /(&lt;\?php|\?&gt;|__(?:DIR|FILE|LINE)__)/,
    punctuation: regexBasics.punctuation,
    number: regexBasics.number,
    boolean: regexBasics.boolean,
    variable: /(\$[\w\d_]+)/,
    keyword: /\b(define|echo|die|exit|print_r|var_dump|if|else|elseif|do|return|case|default|function|\$this|while|foreach|for|switch|in|break|continue|empty|isset|unset|parse_ini_file|session_(?:start|destroy|id)|header|json_(?:encode|decode)|error_log|(require|include)(:?_once)?|try|throw|new|Exception|catch|finally|preg_(?:match|replace)|list|strlen|substr|str_replace|array_(?:keys|values))(?=\W|$)/
  },
  sql: {
    quote: regexBasics.quote,
    comment: /((?:\-\-|#)\s.*?(?:\n|$)|\/\*.*?\*\/)/,
    punctuation: regexBasics.punctuation,
    number: /\b(\d+(?:\.\d+)?|null)\b/,
    boolean: regexBasics.boolean,
    keyword: /\b(\*|CREATE|DATABASE|TABLE|GRANT|ALL|PRIVILEGES|IDENTIFIED|FLUSH|ALTER|MODIFY|DROP|TRUNCATE|CONSTRAINT|ADD|(?:(?:PRIMARY|FOREIGN|UNIQUE) )?KEY|REFERENCES|AUTO_INCREMENT|COMMENT|DEFAULT|UNSIGNED|CHARSET|COLLATE|CHARACTER|ENGINE|SQL_MODE|USE|IF|NOT|NULL|EXISTS|SELECT|UPDATE|DELETE|INSERT(?: INTO)?|VALUES|SET|FROM|WHERE|(?:ORDER|GROUP) BY|LIMIT|(?:(?:LEFT|RIGHT|INNER|OUTER) |)JOIN|AS|ON|COUNT|CASE|TO|WHEN|BETWEEN|AND|OR|IN|LIKE|CONCAT|CURRENT_TIMESTAMP)(?=\W|$)/,
    "var-type": /\b((?:var)?char|(?:tiny|small|medium|big)?int|decimal|float|double|real|bit|boolean|date(?:time)?|time(?:stamp)?|year|(?:tiny|medium|long)?(?:text|blob)|enum)\b/
  }
};
const attributesRegex = {
  xml: /(\s*)([a-zA-Z\d\-:]+)=("|')(.*?)\3/g,
  html: /(\s*)([a-zA-Z-]+)=("|')(.*?)\3/g,
  "html-vue": /(\s*)([@:#]?[a-zA-Z\d-]+)(?:(?:=("|')(.*?)\3)|)/g,
  pug: /(\s*|,)([@:#]?[a-zA-Z\d-]+)(?:(?:=("|')(.*?)\3)|)/g
};
const multiCapturesMapping = {
  shell: { quote: 2 },
  xml: { quote: 2, tag: 4 },
  html: { quote: 2, tag: 4 },
  "html-vue": { quote: 2, tag: 4 },
  pug: { text: 3, text2: 3, quote: 2, comment: 3, tag: 6 },
  json: { quote: 2 },
  php: { quote: 2 },
  sql: { quote: 2 },
  css: { quote: 2 },
  js: { quote: 2 }
};
const __vue2_script = {
  name: "sshpre",
  props: {
    language: { type: String, default: "" },
    label: { type: [String, Boolean], default: false },
    reactive: { type: Boolean, default: false },
    dark: { type: Boolean, default: false },
    copyButton: { type: Boolean, default: false }
  },
  data: () => ({
    knownLanguages: Object.keys(dictionary),
    content: "",
    slotTexts: ""
  }),
  methods: {
    htmlize(string) {
      return string.replace(/&(lt|gt|amp);/g, (m0, m1) => ({ lt: "<", gt: ">", amp: "&" })[m1]);
    },
    unhtmlize(string) {
      return string.replace(/[<>]/g, (m) => ({ "<": "&lt;", ">": "&gt;" })[m]);
    },
    isColorDark(colorString) {
      let rgbColor, hexColor, rDark, gDark, bDark, alphaLow;
      if (rgbColor = colorString.match(/rgba?\((.*),\s*(.*),\s*(.*?)(?:,\s*([^)]*))\)/)) {
        rDark = parseInt(rgbColor[1]) <= 100;
        gDark = parseInt(rgbColor[2]) <= 100;
        bDark = parseInt(rgbColor[3]) <= 100;
        alphaLow = parseFloat(rgbColor[4]) < 0.3;
      } else if (hexColor = colorString.match(/#([\da-f]{3}(?:[\da-f]{3})?)/)) {
        const has3chars = hexColor[1].length === 3;
        rDark = parseInt(hexColor[1][0]) <= 9;
        gDark = parseInt(hexColor[1][has3chars ? 1 : 2]) <= 9;
        bDark = parseInt(hexColor[1][has3chars ? 2 : 4]) <= 9;
      }
      return (rDark && gDark && bDark || rDark && gDark && !bDark || !rDark && gDark && bDark) && !alphaLow;
    },
    createRegexPattern() {
      let pattern = "";
      const classMap = [];
      for (const Class in dictionary[this.language]) {
        const capturesCount = multiCapturesMapping[this.language][Class] || 1;
        for (let i = 0; i < capturesCount; i++)
          classMap.push(Class);
        pattern += (pattern ? "|" : "") + dictionary[this.language][Class].source;
      }
      return [pattern, classMap];
    },
    syntaxHighlightHtmlTag(matches) {
      const renderAttributesList = (_, a, b, c, d) => `${a}<span class="attribute">${b}</span>` + (d ? '<span class="punctuation">=</span>' : "") + (d ? `<span class="quote">${c || ""}${d || ""}${c || ""}</span>` : "");
      let attributesList = (matches[2] || "").replace(attributesRegex[this.language], renderAttributesList);
      if (this.language === "pug") {
        const idAndClasses = (matches[1] || "").replace(/#[a-z\d-]+/g, (m) => `<span class="id">${m}</span>`).replace(/\.[a-z\d-]+/g, (m) => `<span class="class">${m}</span>`);
        if (attributesList) {
          attributesList = `<span class="punctuation">(</span>` + attributesList + `<span class="punctuation">)</span>`;
        }
        return `<span class="tag-name">${matches[0] || ""}</span>${idAndClasses}${attributesList}` + (matches[3] ? '<span class="punctuation">.</span>' : "") + (matches[4] || "") + (matches[5] ? `<span class="text">${matches[5]}</span>` : "");
      }
      return `<span class="punctuation">${matches[0]}</span><span class="tag-name">${matches[1]}</span>` + attributesList + `<span class="punctuation">${matches[3]}</span>`;
    },
    syntaxHighlightContent(string) {
      if (!this.knownLanguages.includes(this.language))
        return string;
      const [regexPattern, classMap] = this.createRegexPattern();
      return this.unhtmlize(string).replace(new RegExp(regexPattern, "gs"), (m, ...matches) => {
        matches = matches.slice(0, matches.length - 2);
        let Class;
        const isPug = this.language === "pug";
        let match = matches.find((m2, i) => m2 && (Class = classMap[i]) && m2);
        if (Class === "quote")
          match = this.unhtmlize(match);
        else if (Class === "comment") {
          if (isPug) {
            const [carretReturn, whitespaces, comment] = matches.slice(classMap.indexOf("comment"));
            match = `${carretReturn}${whitespaces}${this.unhtmlize(comment)}`;
          } else
            match = this.unhtmlize(match);
        } else if (Class === "text" && isPug) {
          return `${matches[0]}<span class="punctuation">|</span>${matches[1]}<span class="text">${matches[2]}</span>`;
        } else if (Class === "text2" && isPug) {
          const [, , , tabs, tagString, text] = matches;
          const tag = this.syntaxHighlightContent(tagString);
          return `${tabs}${tag}<span class="punctuation">.</span>
<span class="text">${text}</span>`;
        } else if (Class === "tag" && ["xml", "html", "html-vue", "pug"].includes(this.language)) {
          return this.syntaxHighlightHtmlTag(matches.slice(classMap.indexOf("tag")));
        } else if (Class === "variable" && match[0] === "." && this.language === "js") {
          return `<span class="punctuation">.</span><span class="obj-attr">${match.substr(1)}</span>`;
        }
        let styles = "";
        if (Class === "color" && this.language === "css") {
          styles = ` style="background-color: ${match};color: #${this.isColorDark(match) ? "fff" : "000"}"`;
        }
        return Class && `<span class="${Class}"${styles}>${match}</span>` || "";
      });
    },
    checkSlots() {
      const slotTexts = (this.$slots.default || []).map((slot) => slot.text || "").join("");
      if (this.slotTexts !== slotTexts) {
        this.slotTexts = slotTexts;
        this.content = this.syntaxHighlightContent(this.slotTexts);
      }
    },
    copyCode(e) {
      e.target.insertAdjacentHTML("afterend", `<textarea id="clipboard-textarea">${this.$refs.code.innerText}</textarea>`);
      const textarea = document.getElementById("clipboard-textarea");
      textarea.select();
      textarea.setSelectionRange(0, 99999);
      document.execCommand("copy");
      textarea.remove();
      this.$emit("copied", this.$refs.code.innerText);
    }
  },
  mounted() {
    this.checkSlots();
  },
  beforeUpdate() {
    if (this.reactive)
      this.checkSlots();
  }
};
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var simpleSyntaxHighlighter = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export { simpleSyntaxHighlighter as default };
